import {Button, Dropdown, Flex, PriorityIcon, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {isRTL} from '../../../Localization';
import {MultiButton} from '../../../_legacy/Searches/components/MultiButton';
import styles from './styles.module.scss';

interface Props {
    onSave: () => void;
    onZoom: () => void;
    onSaveAndConvert: () => void;
    onClose: () => void;
    isSaveDisabled: boolean;
    hasAction: boolean;
}
const Footer = ({onClose, onSave, onSaveAndConvert, onZoom, isSaveDisabled, hasAction}: Props) => {
    const SaveButton = () => (
        <Button
            darkContainer
            size="large"
            width="regularFixed"
            disabled={isSaveDisabled}
            onClick={onSave}
        >
            {getLocalizedText(texts.save)}
        </Button>
    );
    return (
        <Flex componentClasses={styles.footer}>
            <Button
                skin="text"
                suffixIcon={isRTL() ? PriorityIcon.operatorLess : PriorityIcon.operatorGrater}
                onClick={onZoom}
                componentClasses={styles.zoomButton}
            >
                {getLocalizedText(texts.addCustomerDetails)}
            </Button>
            <Flex justifyContent="flex-end">
                <Button
                    size="large"
                    width="regularFixed"
                    componentClasses={styles.footerCloseButton}
                    onClick={onClose}
                    skin="secondary"
                >
                    {getLocalizedText(texts.AppSearchCancel)}
                </Button>
                {hasAction ? (
                    <MultiButton
                        button={<SaveButton />}
                        triggerProps={{
                            darkContainer: true,
                            size: 'large',
                            disabled: isSaveDisabled
                        }}
                    >
                        <Dropdown.Item index={0} divider={true} onClick={onSave}>
                            <Text skin="subtitle-2" textColor="primary-700" wrap={false}>
                                {getLocalizedText(texts.save)}
                            </Text>
                        </Dropdown.Item>

                        <Dropdown.Item index={1} onClick={onSaveAndConvert}>
                            <Text skin="subtitle-2" textColor="primary-700" wrap={false}>
                                {getLocalizedText(texts.saveAndConvert)}
                            </Text>
                        </Dropdown.Item>
                    </MultiButton>
                ) : (
                    <SaveButton />
                )}
            </Flex>
        </Flex>
    );
};

export default Footer;
